var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-input',{model:{value:(_vm.failedOrderJSON),callback:function ($$v) {_vm.failedOrderJSON=$$v},expression:"failedOrderJSON"}}),_c('b-button',{attrs:{"disabled":_vm.wait === true},on:{"click":_vm.submit}},[_vm._v(" Submit ")]),_c('p',[_vm._v(_vm._s(_vm.error))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }